export default __webpack_public_path__ + "static/media/fig-12-hrt-adit-surge.02202954.png";